// Wait for the user to pause typing before firing the (server-side) search
// query. 50ms was effectively no debounce — one request per keystroke.
export const SEARCH_DEBOUNCE_DELAY = 300;
export const DEFAULT_COMPANY_ID = "f0d79e0e-3ff9-4d44-aa98-6609fd264cd7";
// @ts-expect-error: process is a NodeJS global variable
export const STRIPE_PUBLIC_KEY = import.meta.env.VITE_STRIPE_PUBLIC_KEY;
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
export const GOOGLE_FONTS_API_KEY = import.meta.env.GOOGLE_FONTS_API_KEY;
